import state_visits from './state_visits';
import state_return_unneeded from './state_return_unneeded';
import californiaPages from './california';

export default {
    state_return_unneeded: state_return_unneeded,
    state_visits: state_visits,
    ...californiaPages,
};
